import React, { PureComponent } from 'react'
import axios from 'axios'
import { connect } from 'react-redux'
import { getLanguageKeys, getLanguageCode, getUser } from '@/store/getters'
import { updatePdfStatus, setHeaderMode } from '@/store/actions'
import { makeCancelable } from '@/utils/cancelablePromise'
import { getFormatedDate } from '@/constants'

import styles from './styles.scss'

/** Components */
import IconComponent from '@/components/commons/IconComponent'

class ListExported extends PureComponent {
  getMagazines = null
  state = {
    pdfs: []
  }
  componentDidMount () {
    this.props.setHeaderMode( 'exported-pdfs' )
  }
  componentWillReceiveProps ( props ) {
    const {
      user: { id_usuario }
    } = props
    this.getMagazines = makeCancelable(
      axios.get( `${process.env.REACT_APP_API_PDF_URL}/pdf?userId=${id_usuario}` )
    )
    this.getMagazines.promise.then( res => {
      this.setState( {
        pdfs: res.data
      } )
    } )
  }
  componentWillUnmount () {
    this.props.setHeaderMode( 'normal' )
    if ( this.getMagazines ) {
      this.getMagazines.cancel()
    }
  }
  onClickPdf ( { date, magazine_id } ) {
    this.props.updatePdfStatus( {
      id: magazine_id,
      date
    } )
  }
  render () {
    const { pdfs } = this.state
    const { locales, localeCode } = this.props

    return (
      <div className={styles['list-exported']}>
        <ul>
          <li className={styles['informations-pdfs-exported']}>
            <span>
              Magazines
            </span>
            <span>
              {locales['filter-date']}
            </span>
          </li>
          {pdfs.map( ( pdf, index ) => (            
            <li key={index} className={styles['exported-pdf']}>
              <span>
                {pdf.name}
              </span>
              <span>
                {getFormatedDate( pdf.date, false, localeCode )}
              </span>
              <a
                href={`${process.env.REACT_APP_API_URL}/${pdf.path}`}
                target="blank"
                onClick={() => this.onClickPdf( pdf )}
              >
                <IconComponent icon="view" />
              </a>
            </li>
          ) )}
        </ul>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const locales = getLanguageKeys( state )
  const localeCode = getLanguageCode( state )
  const user = getUser( state ).user
  return {
    locales,
    localeCode,
    user
  }
}

export default connect(
  mapStateToProps,
  { setHeaderMode, updatePdfStatus }
)( ListExported )



// WEBPACK FOOTER //
// ./src/pages/ExportedMagazines/index.js